export const GET_SIGNALS = '/user/signal'
